<template>
  <div>
    <v-dialog
      v-show="purchaseTokenDialog"
      v-model="purchaseTokenDialog"
      persistent
      max-width="800px"
      v-scroll-lock="!purchaseTokenDialog"
    >
      <v-card>
        <v-card-title class="headline">
          <span class="mt-3">
            Purchase tokens
          </span>
        </v-card-title>
        <v-card-text>
          <v-row class="ma-0 title">
            <v-col cols="3">
              <v-row class="justify-center">
                <v-col cols="10" class="text-center">
                  Unit price
                </v-col>
              </v-row>
              <v-row class="justify-center">
                <v-col
                  cols="8"
                  class="pt-1 pb-1 text-center"
                  style="color: initial; font-size: 21px;"
                >
                  {{ tokenPlans.TokenUnitPrice }}
                </v-col>
              </v-row>
              <v-row class="justify-center subtitle-2">
                <v-col cols="8" class="text-right">
                  (USD)
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="1" class="d-flex align-center">
              <v-row>
                <v-col cols="8" class="pt-6">
                  ×
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="3">
              <v-row>
                <v-col cols="8" class="text-center">
                  Amount
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="8" class="pa-0">
                  <v-select
                    style="font-size: 20px;"
                    :items="range"
                    v-model="amount"
                    dense
                    outlined
                    max-width="200px"
                    :hide-details="true"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row class="subtitle-2">
                <v-col cols="8" class="text-right">
                  (tokens)
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="1" class="d-flex align-center">
              <v-row>
                <v-col cols="8" class="pt-6">
                  =
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="4">
              <v-row>
                <v-col cols="8" class="text-center">
                  Total
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="8"
                  class="pt-1 pb-1 text-center"
                  style="color: initial; font-size: 21px;"
                >
                  ${{ totalPrice }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-row
          class="justify-space-between"
          style="margin-left: 30px; margin-right: 30px;"
        >
          <v-btn
            class="mb-5"
            color="error"
            @click="setPurchaseTokenDialog(false)"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            style="pointer-events: fill;"
            @click="purchase()"
            :disabled="myPlan.TokenPaymentStatus === 'failure'"
          >
            PURCHASE
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="loadingPurchaseToken"
      hide-overlay
      persistent
      width="300"
    >
      <v-card color="primary" dark>
        <v-card-text>
          Now processing...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <confirm-dialog ref="confirm"></confirm-dialog>
  </div>
</template>

<script>
// import {mapState, mapMutations, mapGetters} from 'vuex'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  name: 'PurchaseTokenDialog',
  components: {
    ConfirmDialog,
  },
  props: {
    purchaseTokenDialog: {
      type: Boolean,
      default: false,
    },
    myPlan: {
      type: Object,
      required: true,
    },
    tokenPlans: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadingPurchaseToken: false,
      range: Array.from(Array(50).keys(), (x) => x + 1),
      amount: 1,
    }
  },
  methods: {
    setPurchaseTokenDialog(show) {
      this.$emit('setPurchaseTokenDialog', show)
    },
    async purchase() {
      if (
        await this.$refs.confirm.open(
          'You are attempting to purchase tokens.',
          'Continue'
        )
      ) {
        this.loadingPurchaseToken = true
        const result = await this.postToken(this.amount)
        if (
          result &&
          result.data &&
          result.data.Status === 'require_action' &&
          result.data.NextActionUrl
        ) {
          window.open(result.data.NextActionUrl, '_self')
        }
        this.loadingPurchaseToken = false
        this.$emit('init')
        this.$emit('setPurchaseTokenDialog', false)
      }
    },
  },
  computed: {
    totalPrice() {
      return this.tokenPlans.TokenUnitPrice * this.amount
    },
  },
  mounted() {},
}
</script>

<style scoped>
.v-data-table__wrapper th {
  font-size: 18px;
  color: #00bfff !important;
}
.v-text-field__details {
  display: none;
}
</style>
